exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.logo[data-v-3b3d0e43] {\r\n  max-height: 180px;\r\n  max-width: 180px;\r\n  margin-bottom: 0px;\n}\n.wrapper[data-v-3b3d0e43] {\r\n  margin-top: -40px;\n}\r\n", ""]);

// exports
